"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserStats = void 0;
function parseUserStats(stats) {
    return {
        sessionModulesStudied: stats.modulesStudied,
        sessionModulesTested: stats.modulesTested,
        sessionModulesCorrect: stats.modulesCorrect,
        sessionModulesIncorrect: stats.modulesIncorrect,
        sessionModulesGaveUp: stats.modulesGaveUp,
        averageScore: stats.averageScore,
        studyDuration: stats.studyDuration,
        sessionsCompleted: stats.sessionsCompleted
    };
}
exports.parseUserStats = parseUserStats;
//# sourceMappingURL=parseUserStats.js.map